module.exports = __webpack_public_path__ + "img/avatar_random_11.e39dc3db.png";